import React, { useEffect } from 'react';
import { Navigate } from "react-router-dom";
import { trimPrefix } from '@karpeleslab/klbfw';
import CircularProgress from "@mui/material/CircularProgress";

const Redirect = ({ target }) => {
    const isExternal = target.startsWith('http');
    
    useEffect(() => {
        if (isExternal) {
            window.location.replace(target);
        }
    }, [isExternal, target]);

    if (!isExternal) {
        const [, targetPath] = trimPrefix(target);
        return <Navigate to={targetPath} replace />;
    }

    return <CircularProgress />;
}

export default Redirect;